<template>
  <div class="menu-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_list'}" class="float-left mr-1 main-link">{{$t('store.outlets')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.details')}}</router-link>
                  / {{$t('store.menu_control')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.outlets') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row" v-if="item != null">
                <b-col cols="12">
                  <!-- Store name -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.outlet_name')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{store_info.name}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Store code -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.outlet_code')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{store_info.code}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Owner Name -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.owner_name')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{store_info.owner_name}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Owner Code -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.owner_code')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{store_info.owner_code}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Address -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.address')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{store_info.address}}</legend>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <router-link :to="{ name: 'outlets_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
              <div class="btn-save" v-if="checkPermission($auth.user(),'post.v1.product-menu-be.menu-outlets')">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-if="isShowPublishButton" v-on:click="publishAll()"> {{$t('common.publish')}}</button>
                <span v-if="!isShowPublishButton" style="padding-right: 20px; font-weight: bold;" > {{$t('common.publishing')}} ... </span>
              </div>
            </div>
          </b-card>
          <!-- Size Exclusion -->
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.size_exclusion')}}
              </strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateSizeStatus" v-b-toggle.size_content>
                <i class="fa fa-sort-down" v-if="sizeStatus"></i>
                <i class="fa fa-sort-up" v-if="!sizeStatus"></i>
              </label>
            </div>

            <b-collapse :visible.sync="sizeStatus" id="size_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive table-bordered">
                      <table class="table table-sm header-pointer">
                        <thead class="table-thead">
                        <tr>
                          <th class="thead-th" width="100">
                            {{$t('store.exclusion_target')}}
                          </th>
                          <th scope="col" class="thead-th" width="200">
                            {{$t('store.code')}}
                          </th>
                          <th scope="col" class="thead-th">
                            {{$t('store.name')}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataFirstSecond.first_layers" :key="index">
                          <td class="text-center">
                            <span>
                              <b-form-checkbox class="checkbox-warning" v-model="dataFirstSecond.first_layers[index].value" value="1" unchecked-value="0"></b-form-checkbox>
                            </span>
                          </td>
                          <td>
                            <span>{{item.sku}}</span>
                          </td>
                          <td>
                            <span>{{item.name[$session.get('lang')]}}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>

          </b-card>

          <!-- Crust Exclusion -->
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.crust_exclusion')}}
              </strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateCrustStatus" v-b-toggle.crust_content>
                <i class="fa fa-sort-down" v-if="crustStatus"></i>
                <i class="fa fa-sort-up" v-if="!crustStatus"></i>
              </label>
            </div>

            <b-collapse :visible.sync="crustStatus" id="crust_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive table-bordered">
                      <table class="table table-sm header-pointer">
                        <thead class="table-thead">
                        <tr>
                          <th class="thead-th" width="100">
                            {{$t('store.exclusion_target')}}
                          </th>
                          <th scope="col" class="thead-th" width="200">
                            {{$t('store.code')}}
                          </th>
                          <th scope="col" class="thead-th">
                            {{$t('store.name')}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataFirstSecond.second_layers" :key="index">
                          <td class="text-center">
                            <span>
                              <b-form-checkbox class="checkbox-warning" v-model="dataFirstSecond.second_layers[index].value" value="1" unchecked-value="0"></b-form-checkbox>
                            </span>
                          </td>
                          <td>
                            <span>{{item.sku}}</span>
                          </td>
                          <td>
                            <span>{{item.name[$session.get('lang')]}}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>

          </b-card>

          <!-- Size & Crust Exclusion -->
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.size_crust_exclusion')}}
              </strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateSizeAndCrustStatus" v-b-toggle.size_crust_content>
                <i class="fa fa-sort-down" v-if="sizeAndCrustStatus"></i>
                <i class="fa fa-sort-up" v-if="!sizeAndCrustStatus"></i>
              </label>
            </div>

            <b-collapse :visible.sync="sizeAndCrustStatus" id="size_crust_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive table-bordered">
                      <table class="table table-sm header-pointer">
                        <thead class="table-thead">
                        <tr>
                          <th class="thead-th" width="100">
                            {{$t('store.exclusion_target')}}
                          </th>
                          <th scope="col" class="thead-th" width="200">
                            {{$t('store.size_name')}}
                          </th>
                          <th scope="col" class="thead-th">
                            {{$t('store.crust_name')}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(value, index) in first_second_layers">
                          <td class="text-center">
                            <span>
                              <b-form-checkbox class="checkbox-warning" v-model="first_second_layers[index].value"  value="1" unchecked-value="0" @input="checkFirstSecond(first_second_layers[index].value, first_second_layers[index])" ></b-form-checkbox>
                            </span>
                          </td>
                          <td>
                            <span>{{value.first.name[$session.get('lang')]}}</span>
                          </td>
                          <td>
                            <span>{{value.second.name[$session.get('lang')]}}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>

          </b-card>

          <!-- Menu Exclusion -->
          <b-card class="mb-0" v-if="(outlet_config.config && (typeof outlet_config.config.show_menu_exclusion === 'undefined' || outlet_config.config.show_menu_exclusion !== false))">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.menu_exclusion')}}
              </strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" v-b-toggle.customise_content>
                <i class="fa fa-sort-down" v-if="commonStatus"></i>
                <i class="fa fa-sort-up" v-if="!commonStatus"></i>
              </label>
            </div>

            <b-collapse :visible.sync="commonStatus" id="customise_content">
              <b-row>
                <b-col cols="6">
                  <b-form-group v-bind:label="$t('store.topping_exclusion')" :label-cols="4" :horizontal="true">
                    <button id="topping_exclusion_btn" class="btn bg-main border-radius-4px" @click="editToppingExclusion" type="button" >{{$t('common.edit')}}</button>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('store.menu_exclusion')" :label-cols="4" :horizontal="true">
                    <button id="menu_exclusion_btn" class="btn bg-main border-radius-4px" @click="editMenuExclusion" type="button" >{{$t('common.edit')}}</button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  let vm = null
  let cancel = null

  export default {
    name: 'MenuGroupForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      Tables,
      cSwitch,
      vSelect,
      Multiselect
    },
    data: function () {
      return {
        is_using_menu_v4_api: false,
        outlet_config: this.$store.getters.config.gms.outlet,
        dataFirstSecond: {
          first_layers: [],
          second_layers: []
        },
        firstSecondTmp: [],
        single: this.$store.getters.config.gms.menu,
        images: ['desktop_thumbnail', 'desktop_detail', 'mobile_thumbnail', 'mobile_detail'],
        outletInfo: { code: '', name: {}, description: {}, address: '' },
        modelFirstCheckAll: 0,
        modelSecondCheckAll: 0,
        item: {
          uuid: "",
          name: {},
          group_name: {},
          marketing_description: {},
          main_description: {},
          t_and_c: {},
          image: {},
          active: 1,
          menus: []
        },
        imageData: {},
        basicInformationStatus: true,
        commonStatus: true,
        sizeStatus: true,
        crustStatus: true,
        sizeAndCrustStatus: true,
        processing: false,
        menuDealList: {},
        menuDealListUpdated: [],
        menuDealListSelected: '',
        isLoadingMenu: false,
        isLoadingMenuGroup: false,
        store_info: {
          name: '',
          code: '',
          owner_name: '',
          owner_code: '',
          address: ''
        },
        first_layers: [],
        second_layers: [],
        first_second_layers: [],
        isShowPublishButton: false
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {

    },
    methods: {
      checkPermission(userInfo,permission){
        let modules = userInfo.modules ? userInfo.modules : {}
        let adminIds = [1, 34, 35, 62]
        return adminIds.indexOf(userInfo.user_id) !== -1 || modules.indexOf(permission) !== -1;
      },
      checkShowPublishButton() {
        let getCache = vm.getCacheLocalStorage(vm.store_info.code + '_' + 'pushlish')
        vm.isShowPublishButton = true
        if (!getCache.expired) {
          vm.isShowPublishButton = false
        }
      },
      publishAll () {
        vm.saveMenuControlFirstSecond(() => {
          const menuParams = {
            'scope': 'all',
            'outlet': {
              'uuid': this.$route.params.uuid,
              'code': this.outletInfo.code
            }
          }
          if (!this.is_using_menu_v4_api || this.is_using_menu_v4_api === false) {
            menuParams.publish_pizza = 1
          }
          vm.axios.menu.publishMenu(menuParams, function (response) {
            // vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            // vm.ids = []
            // vm.refreshData()
          })

          vm.axios.menu.publishCombo({
            'scope': 'all',
            'outlet': {
              'uuid': this.$route.params.uuid,
              'code': this.outletInfo.code
            }
          }, function (response) {
            // vm.$toastr.success(vm.$t('success'), vm.$t('success'), {})
            // vm.refreshData()
          })
        })
        vm.isShowPublishButton = true
        if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
          vm.isShowPublishButton = false
          let time = Number(vm.$store.getters.config.manual_config.set_time_show_button_push_to_prod_store)
          time = Number.isNaN(time) ? 5 : time
          vm.setCacheLocalStorage(  this.outletInfo.code + '_' + 'pushlish', true, time )
        }

      },
      editMenuExclusion () {
        this.$router.push({name: 'menu_exclusion', params: {uuid: this.$route.params.uuid}})
      },
      editToppingExclusion () {
        this.$router.push({name: 'topping_exclusion', params: {uuid: this.$route.params.uuid}})
      },
      checkFirstSecond (value, item) {
        let check = this.firstSecondTmp.indexOf(item)
        if (check > -1) {
          if (typeof this.firstSecondTmp[check].first.value.second !== "undefined") {
            let index = this.firstSecondTmp[check].first.value.second.indexOf(item.second.uuid)
            if (value === '0') {
              this.firstSecondTmp[check].first.value.second.splice(index, 1)
            }
          }
          // let index = this.firstSecondTmp[check].first.value.second.indexOf(item.second.uuid)
          // console.log(index)
          // if (index > -1) {
          //   this.firstSecondTmp.first.value.second.splice(index, 1)
          // }
        } else {
          item.value = value
          this.firstSecondTmp.push(item)
        }
      },
      refreshDataFirstAndSeconds () {
        let data = {outlet_code: this.outletInfo.code}
        this.axios.menu.listFirstAndSeconds(data,
          function (response) {
            vm.dataFirstSecond = response.data.data.items
            for (let i in vm.dataFirstSecond.first_layers) {
              if (vm.dataFirstSecond.first_layers[i].id === null) {
                vm.dataFirstSecond.first_layers.splice(i, 1)
              }
              if (vm.dataFirstSecond.first_layers[i].id.length < 1) {
                vm.dataFirstSecond.first_layers.splice(i, 1)
              }
              vm.dataFirstSecond.first_layers[i].uuid = 'first_' + vm.dataFirstSecond.first_layers[i].id
            }
            for (let i in vm.dataFirstSecond.second_layers) {
              if (vm.dataFirstSecond.second_layers[i].id === null) {
                vm.dataFirstSecond.second_layers.splice(i, 1)
              }
              if (vm.dataFirstSecond.second_layers[i].id.length < 1) {
                vm.dataFirstSecond.second_layers.splice(i, 1)
              }
              vm.dataFirstSecond.second_layers[i].uuid = 'second_' + vm.dataFirstSecond.second_layers[i].id
            }

            let first_second_layers = []
            for (let i in vm.dataFirstSecond.first_layers) {
              let firstValue = vm.dataFirstSecond.first_layers[i].value
              if (vm.dataFirstSecond.first_layers[i].id !== null) {
                for (let j in vm.dataFirstSecond.second_layers) {
                  let data = {
                    first: vm.dataFirstSecond.first_layers[i],
                    second: vm.dataFirstSecond.second_layers[j],
                    value: 0
                  }
                  if (typeof firstValue.second !== 'undefined') {
                    let checkSecond = firstValue.second.indexOf('second_' + vm.dataFirstSecond.second_layers[j].id)
                    if (checkSecond > -1) {
                      data.value = 1
                    }
                  }
                  first_second_layers.push(data)
                }
              }
            }
            vm.first_second_layers = first_second_layers
          })
      },
      secondCheckAll (val) {
        for (let i in this.dataFirstSecond.second_layers) {
          this.dataFirstSecond.second_layers[i].value = val
        }
      },
      saveMenuControlFirstSecond (cb) {
        let data = {
          outlet_code: this.outletInfo.code,
          layers: []
        }

        for (let i in this.dataFirstSecond.first_layers) {
          let firstValue = []
          if (this.dataFirstSecond.first_layers[i].value !== '1') {
            for (let fs in this.first_second_layers) {
              if (this.dataFirstSecond.first_layers[i].uuid === this.first_second_layers[fs].first.uuid && this.first_second_layers[fs].value == 1) {
                firstValue.push(this.first_second_layers[fs].second.uuid)
              }
            }
            if (firstValue.length > 0) {
              this.dataFirstSecond.first_layers[i].value = {
                second: firstValue
              }
            } else {
              this.dataFirstSecond.first_layers[i].value = 0
            }
          }
        }
        data.layers = this.dataFirstSecond.first_layers.concat(this.dataFirstSecond.second_layers)
        vm.axios.menu.saveMenuControl(data, function (response) {
          vm.refreshDataFirstAndSeconds()
          vm.$toastr.success(vm.$t('message.success'), vm.$t('message.success'), {})
          cb()
        }, function (data) {
          vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
        })
      },
      /**
       * update status of customise session
       */
      updateSizeStatus () {
        this.sizeStatus = this.sizeStatus?false:true
      },
      updateCrustStatus () {
        this.crustStatus = this.crustStatus?false:true
      },
      updateSizeAndCrustStatus () {
        this.sizeAndCrustStatus = this.sizeAndCrustStatus?false:true
      },
      updateCommonStatus () {
        this.commonStatus = this.commonStatus?false:true
      },
      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = this.basicInformationStatus?false:true
      },
      /**
       * preview image after select
       * @param event
       */
      previewImage (event) {
        let input = event.target

        if (input.files && input.files[0]) {
          let reader = new FileReader()

          reader.onload = (e) => {
            this.imageData[input.id] = e.target.result
          }
          // this.imageData = []
          let data = {}
          for (let i in this.images) {
            data[this.images[i]] = this.imageData[this.images[i]]
          }
          this.imageData = data
          reader.readAsDataURL(input.files[0])
          this.item.image[input.id] = input.files[0]
        }
      },
      readyPublish (uuid) {
        vm.axios.menu.publishMenuGroup(uuid, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.$router.push({name: 'menu_group_list'})
        })
      },
      /**
       * upload image then move to next form
       */
      saveData () {
        var item = JSON.parse(JSON.stringify(vm.item))
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        vm.axios.menu.uploadImages(formData, config, function (response) {
          item.image = {}
          for (let i in response.data.data) {
            item.image[i] = response.data.data[i]
          }
          // get old url
          for (let i in oldUrl) {
            item.image[i] = oldUrl[i]
          }
          vm.imageData = item.image

          // process menus data
          item.menus = []
          for (let i in vm.menuDealListSelected) {
            item.menus.push({
              menu_id: vm.menuDealListSelected[i].value,
              type: vm.menuDealListSelected[i].is_combo ? 2 : 1
            })
          }

          // check create or update
          vm.processing = true
          if (vm.id == 'create' || vm.id == undefined) {
            vm.axios.menu.addMenuGroup(item, function (response) {
              vm.processing = false
              vm.$router.push({name: 'menu_group_list'})
            }, function () {
              vm.processing = false
            })
          } else {
            vm.axios.updateMenuGroup(item, function (response) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.processing = false
              vm.$router.push({name: 'menu_group_list'})
            }, function () {
              vm.processing = false
            })
          }
        })
      },
      /**
       * get list categories for select box
       */
      getDealMenuList () {
        let params = '?group=1'
        vm.isLoadingMenu = true
        vm.axios.menu.getListDealMenu(params, function(response){
          let data = response.data.data.items
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.menuDealList[langs[l]] = []
            for (let c in data) {
              let item = data[c]
              if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
                vm.menuDealList[langs[l]].push({
                  value: item['id'],
                  text: item['sku'] + ' - ' + item['name'][langs[l]],
                  is_combo: item['is_combo']
                })
              }
            }
          }
          vm.isLoadingMenu = false
          vm.$forceUpdate('menuDealList')
        })
      },
      getMenuGroupDetail () {
        vm.isLoadingMenuGroup = true
        vm.axios.menu.getMenuGroupDetail(vm.id,
          function (response) {
            let item = response.data.data.item
            vm.item = item
            let langs = vm.$store.getters.languages
            if (vm.item.main_description.length == 0 || Object.getPrototypeOf(Object(vm.item.main_description)) === Object.getPrototypeOf([])) {
              vm.item.main_description = {}
            }
            if (vm.item.t_and_c.length == 0 || Object.getPrototypeOf(Object(vm.item.t_and_c)) === Object.getPrototypeOf([])) {
              vm.item.t_and_c = {}
            }
            if (vm.item.marketing_description.length == 0 || Object.getPrototypeOf(Object(vm.item.marketing_description)) === Object.getPrototypeOf([])) {
              vm.item.marketing_description = {}
            }
            if (vm.item.group_name.length == 0 || Object.getPrototypeOf(Object(vm.item.group_name)) === Object.getPrototypeOf([])) {
              vm.item.group_name = {}
            }
            if (vm.item.name.length == 0 || Object.getPrototypeOf(Object(vm.item.name)) === Object.getPrototypeOf([])) {
              vm.item.name = {}
            }

            for (let i in vm.images) {
              vm.imageData[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
            }

            vm.menuDealListSelected = []
            for (let i in item.menus) {
              let menuID = item.menus[i].menu_id
              let selected=vm.menuDealListUpdated.filter(function(item){
                return item.value==menuID
              })
              vm.menuDealListSelected.push({
                value: item.menus[i].menu_id,
                text: selected[0].text,
                is_combo: item.menus[i].type
              })
            }
          })
      }
    },
    created: function () {
      vm = this
      if (this.$route.params.uuid) {
        if(this.$store.getters.config.gms.outlet.config.show_menu_out_of_stock){
          this.$router.push({path: '/outlets/outlet-out-of-stock/' + this.$route.params.uuid});
        }
        this.axios.outlet.getOutletDetail(this.$route.params.uuid,
          function (response) {
            const config = vm.$session.get('config')
            const manualConfig = vm._.get(config, 'manual_config', {}) || {}

            let item = response.data.data.item

            const isUsingMenuV4Api = (manualConfig.use_menu_v4_api_stores ? manualConfig.use_menu_v4_api_stores.split(',') : []).includes(item.code)
            vm.is_using_menu_v4_api = isUsingMenuV4Api
            console.log('is_using_menu_v4_api_menu_control', vm.is_using_menu_v4_api)

            vm.$set(vm.outletInfo, 'id', item.id)
            vm.$set(vm.outletInfo, 'code', item.code)
            vm.$set(vm.outletInfo, 'name', item.name ? item.name : {})
            vm.$set(vm.outletInfo, 'description', item.description ? item.description : {})
            vm.$set(vm.outletInfo, 'address', item.address)
            vm.refreshDataFirstAndSeconds()
          })
      }
    },
    mounted: function () {
      // get store information
      vm = this
      vm.axios.outlet.getOutletDetail(vm.uuid, respone => {
        if (respone.status === 200) {
          let data = respone.data.data.item
          vm.store_info.name = data.name[vm.$session.get('lang')]
          vm.store_info.code = data.code
          vm.store_info.owner_name = data.owner_name
          vm.store_info.owner_code = data.owner_code
          vm.store_info.address = data.address[vm.$session.get('lang')]
          if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
            vm.checkShowPublishButton()
          } else {
            vm.isShowPublishButton = true
          }
        }
      }, error => {
        console.log('error', error)
      })

    }
  }
</script>

<style scoped>
  .menu-group-form .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-group-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-group-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-group-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-group-form .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-group-form .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }
</style>

<style>

  .menu-group-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-group-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .preview-image {
    width: 100%;
  }
  .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }
  .points i {
    position: absolute;
  }
  .step-commit {
    margin-left: calc(0% - 10px);
  }
  .step-updated {
    margin-left: calc(33% - 15px);
  }
  .step-publishing {
    margin-left: calc(66% - 15px);
  }
  .step-publish {
    margin-left: calc(100% - 20px);
  }
  .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .current-point {
    font-size: 30px;
  }
  .img-min-height {
    min-height: 161px;
  }
  .custom-checkbox {
    padding-left: 0px;
  }
  .min-width-200{
    min-width: 200px;
  }
  .menu-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .rectangle-9-copy {
    width: auto;
    border: 1px solid #E1E6EB;
    border-radius: 3px;
    background-color: #F5F7F9;
  }

  .rectangle-9-copy-header {
    height: 49px;
    width: auto;
    border-radius: 3px 3px 0 0;
    background-color: #E1E6EB;
  }

  .thead-th {
    padding: 0.4rem !important;
  }

  .table-thead {
    background-color: #c3cbd4;
  }

  #menu_exclusion_btn, #topping_exclusion_btn {
    height: 39px;
    width: 149px;
  }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/outlets/MenuControlForm.vue